import { sortBy, fromPairs } from "lodash";

const sortByKeys = (object: Record<string, unknown>) => {
  const keys = Object.keys(object);
  const sortedKeys = sortBy(keys);
  return fromPairs(sortedKeys.map(key => [key, object[key]]));
};

export default sortByKeys;
